const Mutations = Object.freeze({
	SET_INITIALIZED: 'projectSettings/SET_INITIALIZED',
});

export const Actions = Object.freeze({
	CLEAR: 'projectSettings/CLEAR',
});

export const Getters = Object.freeze({
	INITIALIZED: 'projectSettings/IS_INITIALIZED',
});

import dataFields from './dataFields';
import referenceLists from './referenceLists';
import generalSettings from './generalSettings';
import mergeConditions from './mergeConditions';
import connectors from './connectors/connectors';
import { DataFieldsActions, ReferenceListsActions } from '../../../../actions';
export default {
	state: {
		initialized: true,
	},
	modules: {
		dataFields,
		referenceLists,
		generalSettings,
		mergeConditions,
		connectors,
	},
	mutations: {
		[Mutations.SET_INITIALIZED](state, value) {
			state.isInitialized = value;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit, dispatch }) {
			return new Promise((resolve) => {
				Promise.all([
					dispatch(DataFieldsActions.CLEAR),
					dispatch(ReferenceListsActions.CLEAR),
				]).then(() => {
					commit(Mutations.SET_INITIALIZED, false);
					resolve();
				});
			});
		},
	},
	getters: {
		[Getters.INITIALIZED]: (state) => {
			return state.initialized;
		},
	},
};
